import { Pipe, PipeTransform } from '@angular/core';
import { EventGuest } from '../models/events/guests/event-guest.model';
import { Person } from '../models/people/people/person.model';

@Pipe({
  name: 'fullname'
})
export class FullnamePipe implements PipeTransform {

  transform(value: EventGuest | Person, nameFirst: boolean = false): any {
    if (nameFirst) {
      return value.name + ' ' + value.surname + (value.lastname ? ' ' + value.lastname : '');
    } else {
      return value.surname + (value.lastname ? ' ' + value.lastname : '') + ', ' + value.name;
    }
  }

}
